export const FETCHING_DOSSIERS = 'FETCHING_DOSSIERS';
export const UPDATING_USERCREATION = 'UPDATING_USERCREATION';